import { NotesViewMode, ToolbarItemKey } from "@/features/notes/types";
import { TodoDatePeriod } from "@/features/todos/types";
import { supabase } from "@/services/supabase/client";
import { Database } from "@/services/supabase/types";
import { Theme } from "@/types/common";

type DbUserSettings = Database["public"]["Tables"]["user_settings"];
export interface UserSettingsRow extends Omit<DbUserSettings["Row"], "settings"> {
  settings: UserSettings;
}
export interface UserSettingsInsert extends Omit<DbUserSettings["Insert"], "settings"> {
  settings?: UserSettings;
}
export interface UserSettingsUpdate extends Omit<DbUserSettings["Update"], "settings"> {
  settings?: UserSettings;
}

export interface ToolbarItemSetting {
  id: ToolbarItemKey;
  enabled: boolean;
}

export interface UserSettings {
  app: {
    theme: Theme;
    encryption: boolean;
    onboardingDone: boolean;
  };
  notes: {
    viewMode: NotesViewMode;
    editorToolbarItems: ToolbarItemSetting[];
    ttsLanguage: string;
  };
  todos: {
    filters: {
      period: TodoDatePeriod;
    };
  };
}

export type PartialSettings = {
  app?: Partial<UserSettings["app"]>;
};

async function getUserSettings(): Promise<UserSettings> {
  const { data, error } = await supabase.from("user_settings").select("settings").single();

  if (error) throw error;

  return data.settings;
}

async function updateUserSettings(userId: string, settings: UserSettings): Promise<UserSettings> {
  const { data, error } = await supabase
    .from("user_settings")
    .update({ settings })
    .eq("id", userId)
    .select("settings")
    .single();

  if (error) throw error;

  return data.settings;
}

export const userSettingsFetchers = {
  getUserSettings,
  updateUserSettings,
};
